import React from "react";

const Loader = () => {
  return (
    <div>
      <div class="pre-loader loader1" >
        <div class="loader-inner">
          <span class="loader-content"></span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
